//Store
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import { sendOTP, updateMobile } from '../../../redux/slices/user'

//Components
import LoginPhoneNumber from '../../../components/LoginPhoneNumber'
import WrapperButton from '../../../components/WrapperButton'
import Checkbox from '../../../components/Checkbox'

//Static
import React, { useEffect, useState } from 'react'
import { endPoints, GA } from '../../../constants'
import { PhoneVerificationWrapper, Heading } from './styles'

//Types
import { InputTypes, PhoneVerificationType } from '../../../types/components'
import { APIMethods, ReqBodyWithHeaders } from '../../../types/state'

//GA
import { setWindowGA } from '../../../helpers/DTM'
import { useTransition, animated } from 'react-spring'
import { setErrorStatus } from '../../../redux/slices/meta'
import { setErrorToast } from '../../../helpers/errorStyles'

//Icons
import whatsappIcon from '../../../asset/whatsapp_icon.png'

const PhoneVerification = ({
	whatsAppCheck,
	whatsAppChecked,
}: PhoneVerificationType) => {
	const dispatch = useDispatch()
	const [isLoaded, setIsLoaded] = useState(false)

	const transition = useTransition(isLoaded, {
		from: { opacity: 0, transform: 'translateX(-20px)', delay: 100 },
		enter: { opacity: 1, transform: 'translateX(0)', delay: 100 },
		leave: { opacity: 0, transform: 'translateX(20px)', delay: 100 },
	})
	useEffect(() => {
		setIsLoaded(true)
		const listener = () => {
			const userAgent = navigator.userAgent.toLowerCase()
			const Android = userAgent.indexOf('android') > -1
			if (Android) {
				window.scrollTo(0, document.body.scrollHeight)
			} else {
				document.body.style.margin = '0'
			}
		}
		window.visualViewport.addEventListener('resize', listener)
	}, [])

	const userData = useSelector((state: RootState) => state.user)
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)

	useEffect(() => {
		if (metaData.isError) {
			setErrorToast(metaData.errorMessage)
			dispatch(setErrorStatus({ status: false, message: '' }))
		}
	}, [metaData.isError, metaData.errorMessage, dispatch])

	const onButtonClick = () => {
		setWindowGA({
			event: GA.eventName,
			pageName: GA.phoneVerificationPage,
			pageURL: window.location.href,
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		})
		const reqObj: ReqBodyWithHeaders = {
			method: APIMethods.POST,
			url: endPoints.sendOTP,
			telephone: userData.phone,
			captcha: null,
			phoneCode: '+91',
			client: metaData.deviceType,
			sessionId: userData.sessionId,
		}
		dispatch(sendOTP(reqObj))
	}

	const onInputValidate = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value.length > 0 && e.target.value.length <= 10) {
			dispatch(updateMobile(+e.target.value))
		} else if (e.target.value.length === 0) {
			dispatch(updateMobile(''))
		}
	}

	const onEnterHandler = (e: React.KeyboardEvent<HTMLDivElement>) => {
		if (e.key === 'Enter') {
			onButtonClick()
		}
	}

	return (
		<>
			{transition((style, item) =>
				item ? (
					<animated.div style={style}>
						<Heading>Enter Phone Number</Heading>
						<PhoneVerificationWrapper device={metaData.deviceType}>
							<LoginPhoneNumber
								name={translations.LOGIN_PH_NAME}
								type={InputTypes.NUMBER}
								label={translations.LOGIN_PH_LABEL}
								value={userData.phone === null ? '' : userData.phone}
								changeHandler={onInputValidate}
								onEnterPress={(
									e: React.KeyboardEvent<HTMLDivElement>
								) => onEnterHandler(e)}
							/>
							<Checkbox
								checked={whatsAppChecked}
								onClick={whatsAppCheck}
							>
								{translations.WHATSAPP_TEXT}
								<img
									src={whatsappIcon}
									alt={translations.WHATSAPP_ALT}
								/>
							</Checkbox>
							<WrapperButton
								isLoading={metaData.isLoading}
								buttonClickHandler={onButtonClick}
								isEnabled={userData?.phone?.toString().length === 10}
								btnText={translations.CONTINUE}
							/>
						</PhoneVerificationWrapper>
					</animated.div>
				) : (
					''
				)
			)}
		</>
	)
}

export default PhoneVerification
